import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

export const HiddenTagMeasurement = styled.div`
    display: flex;
    gap: ${theme.space[4]};
    left: 0;
    pointer-events: none;
    position: fixed;
    top: 0;
    visibility: hidden;
`;
